import { DEVICE_MAP } from '../constants/deviceMapping';
import { getUsageType } from './helpers';

export const getDeviceDataFromMapping = (deviceTypeName) => {
  if (!deviceTypeName) {
    return null;
  }

  const data = DEVICE_MAP.find((item) =>
    item.deviceTypeName.includes(deviceTypeName),
  );

  return data;
};

export const isRecommendToUpdatePlan = (usage) => {
  const type_of_usage = getUsageType(usage);
  return type_of_usage === 'High Usage';
};

export const getAssociatedVariants = (
  product,
  productOptions,
  curVariantId,
) => {
  if (!product) return [];

  const variants = product.variants || [];
  let associatedVariants = product.variants;
  const curVariant = variants.find(
    (variant) => variant.external_variant_id === curVariantId,
  );

  const requireFiltering = product.options.length > 1;
  if (requireFiltering) {
    const planOptionIndex = product.options.findIndex(
      (option) => option.name?.toLowerCase() === 'plan',
    );

    if (planOptionIndex !== -1) {
      associatedVariants = variants.filter((variant) =>
        filterPlanVariants({
          variant,
          curVariant,
          planOptionIndex,
          optionsCount: product.options.length,
        }),
      );
    } else {
      associatedVariants = variants.filter((variant) => {
        return (
          productOptions.find((option) =>
            variant.option_values?.includes(option),
          ) && variant.is_deleted === false
        );
      });
    }
  }
  return associatedVariants;
};

/**
 * Checks that all options except `plan` is the same
 */
const filterPlanVariants = ({
  variant,
  curVariant,
  planOptionIndex,
  optionsCount,
}) => {
  if (variant?.external_variant_id === curVariant?.external_variant_id)
    return true;
  if (variant.is_deleted) return false;

  let isSuitable = true;
  for (let i = 0; i < optionsCount; i++) {
    if (i === planOptionIndex) {
      isSuitable &&= variant?.option_values[i] !== curVariant?.option_values[i];
    } else {
      isSuitable &&= variant?.option_values[i] === curVariant?.option_values[i];
    }
  }

  return isSuitable;
};

export const getUpgradeVariant = (productData, upgradeData) => {
  return productData?.variants?.find((variant) => {
    return (
      variant?.external_variant_id?.toString() ===
      upgradeData?.variantId?.toString()
    );
  });
};
